export enum PartnerFilterKey {
  name = 'name',
  status = 'status',
  industry = 'industry',
}
